export default __webpack_public_path__ + "static/04_integrate-cdd1bcfbfd9f20fc04f5700244c1c9a3.webm";